export default __webpack_public_path__ + "e461004378d554cc961525fbaa919296.svg";